import { useLazyQuery } from '@apollo/client'
import {
  EditPageDetailsResponse,
  EditPageDetailsVariables,
  GET_EDIT_PAGE_DETAILS,
} from 'queries/get-cache-edit-page-details'

interface PrewarmResult {
  success: boolean
  errorMessage?: string
}

export const useGetEditPageDetails = () => {
  const [getEditPageDetails, { loading }] = useLazyQuery<
    EditPageDetailsResponse,
    EditPageDetailsVariables
  >(GET_EDIT_PAGE_DETAILS, {
    fetchPolicy: 'network-only',
  })

  const prewarmEditPage = async (
    dealId: number,
    currentUserEmail?: string
  ): Promise<PrewarmResult> => {
    try {
      const result = await getEditPageDetails({ variables: { dealId, currentUserEmail } })

      if (result.data?.editPageDetails?.isSuccess) {
        return { success: true }
      } else {
        const errorMessage =
          result.data?.editPageDetails?.errorMessage ?? 'Failed to load edit page data'
        return { success: false, errorMessage }
      }
    } catch (error) {
      console.error('Error prewarming edit page:', error)
      return { success: false, errorMessage: 'Network error occurred while loading edit page' }
    }
  }

  return {
    prewarmEditPage,
    loading,
  }
}
